import React from "react";
import LocalSalesRep from "./local-sales-rep.jsx";
import LoaderSection from "../loader.jsx";

const NationalOrOnlineState = props => {
    let loader;
    let count = 1;
    if (props.state.loading) loader = <LoaderSection show={true} />;
    const localState = props.state.dealers.map((item) => (
        <LocalSalesRep
            id={count++}
            account={item}
            type={props.state.searchType}
            key={count}
        />
    ));

    return (
        <div>
            <div className="intl-loader">{loader}</div>
            <div className="row dealer-info-row">{localState}</div>
        </div>
    );
};

export default NationalOrOnlineState;